import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';

import { ApiError } from '@shared/api/problem';
import { Button, Container, StateBlock } from '@shared/ui';

import styles from './RouteErrorBoundary.module.css';

/** Ошибка маршрута: 404 отдаём как «не найдено», остальное — как сбой с retry. */
export function RouteErrorBoundary() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <div className={styles.wrapper}>
        <Container width="narrow">
          <StateBlock title={t('notFound.title')} description={t('notFound.description')} />
        </Container>
      </div>
    );
  }

  const requestId = error instanceof ApiError ? error.requestId : null;
  const description = requestId
    ? `${t('error.description')} ${t('error.requestId', { id: requestId })}`
    : t('error.description');

  return (
    <div className={styles.wrapper}>
      <Container width="narrow">
        <StateBlock
          tone="error"
          title={t('error.title')}
          description={description}
          action={
            <Button
              variant="secondary"
              onClick={() => {
                void navigate(0);
              }}
            >
              {t('error.retry')}
            </Button>
          }
        />
      </Container>
    </div>
  );
}
